import { useMutation, gql } from '@apollo/client';
import {
  DeletarProfessorMutation,
  DeletarProfessorMutationVariables,
} from './__generated__/DeletarProfessorMutation';

const DELETAR_PROFESSOR_MUTATION = gql`
  mutation DeletarProfessorMutation($id_professor: Int!) {
    deletarProfessor(id_professor: $id_professor) {
      id_professor
    }
  }
`;

const useDeletarProfessorMutation = () => {
  return useMutation<DeletarProfessorMutation, DeletarProfessorMutationVariables>(
    DELETAR_PROFESSOR_MUTATION
  );
};

export { useDeletarProfessorMutation };
